import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux/hooks";
import { selectedUser, verifyJwt } from "../authSlice";
import {
  generateSubscriptionAPIGTMEvent,
  pushGTMEvent,
} from "../../../shared/helpers/gtm";
import { emailStatuses } from "../models/EmailStatus.interface";

const PublicRoute = ({ page, accessibleWhenLoggedIn }: { page: JSX.Element, accessibleWhenLoggedIn?: boolean }) => {
  const { isAuthenticated, signup, identity, verificationEmail } = useAppSelector(selectedUser);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(verifyJwt());
  }, []);

  useEffect(() => {
    if (signup?.isSuccess && identity && signup?.plan) {
      const { plan } = signup;
      const event = generateSubscriptionAPIGTMEvent({ identity, plan });
      pushGTMEvent(event);
    }
  }, [identity, signup, dispatch]);

  if (isAuthenticated && verificationEmail?.emailStatus === emailStatuses.NotVerified) {
    return page
  } else if (isAuthenticated && !accessibleWhenLoggedIn) {
    return <Navigate replace to="/" />
  } else {
    return page;
  }
};

export default PublicRoute;


